import {
    COMMISSIONS_GET_PERIOD_BEGIN,
    COMMISSIONS_GET_PERIOD_SUCCESS,
    COMMISSIONS_GET_PERIOD_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GET_PERIOD_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies,
            getCommissionsPeriodsPending: true 
          }
        }
      case COMMISSIONS_GET_PERIOD_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies, 
            getCommissionsPeriodsPending: false,
            getCommissionsPeriodsSuccess: false,
            getCommissionsPeriodsError: null,
            listCommissionsPeriods:action.data, 
          }
        }
      case COMMISSIONS_GET_PERIOD_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies,
            getCommissionsPeriodsSuccess: false,
            getCommissionsPeriodsPending: false,
            getCommissionsPeriodsError: action.data,
            listCommissionsPeriods: []
          }
        }
      default:
        return state
    }
  }